enum ActionTypes {
    UPDATE_THEME_PREFERENCE = "theme/updateThemePreference",
    UPDATE_ACTIVE_THEME = "theme/updateActiveTheme"
}

export default ActionTypes;
